<div class="app-pos-customer">
  <div class="left-side">
    <div class="summary-container">
      <div class="summary-header">ยอดที่ต้องชำระ</div>
      <div class="summary-body">
        <div class="summary-text-box">
          <p class="name">จำนวนสินค้า</p>
          <p class="amount">{{ currentBill ? (currentBill.pos_bill_items.length | number) : (0 | number) }}</p>
          <p class="unit">รายการ</p>
        </div>
        <div class="summary-text-box">
          <p class="name">ราคารวม</p>
          <p class="amount">{{ currentBill ? (currentBill.total_price | number : '1.2-2') : (0 | number : '1.2-2') }}</p>
          <p class="unit">บาท</p>
        </div>
        <div class="summary-text-box box-red">
          <p class="name">ส่วนลด</p>
          <p class="amount">{{ currentBill ? (currentBill.total_discount | number : '1.2-2') : (0 | number : '1.2-2') }}</p>
          <p class="unit">บาท</p>
        </div>
        <div class="summary-text-box box-large">
          <p class="name">ยอดที่ต้องชำระ</p>
          <p class="amount">
            {{ currentBill ? (currentBill.total_price - currentBill.total_discount | number : '1.2-2') : (0 | number : '1.2-2') }}
          </p>
          <p class="unit">บาท</p>
        </div>
      </div>
    </div>
    <div class="product-container">
      <div class="product-header">รายการสินค้า</div>
      <div class="product-body">
        <div class="product-list-header">
          <div class="product-list-group">
            <div class="product-header-element">รายการ</div>
            <div class="product-header-element">จำนวน</div>
            <div class="product-header-element">ราคา</div>
          </div>
        </div>
        <div class="product-list-container">
          <ng-container *ngIf="currentBill">
            <ng-container *ngFor="let item of currentBill.pos_bill_items">
              <div class="product-list-group">
                <div class="product-element">{{ item.raw_material_name }}</div>
                <div class="product-element">{{ item.amount | number : '1.1-1' }}</div>
                <div class="product-element">{{ item.amount * item.price | number : '1.2-2' }}</div>
              </div>
            </ng-container>

            <ng-container *ngFor="let item of currentBill.pos_bill_promotion_items">
              <div class="product-list-group list-promotion">
                <div class="product-element">{{ item.promotion_name }}</div>
                <div class="product-element">{{ item.discount_amount }}{{ item.is_discount_percent ? '%' : '' }}</div>
                <div class="product-element">{{ item.total_discount | number : '1.2-2' }}</div>
              </div>
            </ng-container>
            <ng-container *ngFor="let item of currentBill.pos_bill_discount_items">
              <ng-container *ngIf="item.total_discount !== 0">
                <div class="product-list-group list-promotion">
                  <div class="product-element">ส่วนลดพิเศษ</div>
                  <div class="product-element">{{ item.discount_amount }}{{ item.is_discount_percent ? '%' : '' }}</div>
                  <div class="product-element">{{ item.total_discount | number : '1.2-2' }}</div>
                </div>
              </ng-container>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <div class="right-side">
    <div class="app-logo-container">
      <div class="logo-box">
        <!-- <div class="circle-box">
          <div class="inner-circle">LOGO</div>
        </div> -->
        <img
          alt="Logo"
          class="logo"
          class="h-100px logo"
          src="./assets/logo/farm-run-logo-2x.png"
        />
      </div>
      <div class="logo-title-container">
        <p>ยินดีต้อนรับ</p>
        <p>FarmRun</p>
      </div>
    </div>

    <div class="dashboard-container">
      <ng-container *ngIf="!currentPayment">
        <div class="recommend-product-container">
          <div class="recommend-product-header" *ngIf="recommendProductList.length !== 0">รายการสินค้าแนะนำ</div>
          <div class="carousel-box">
            <ngb-carousel
              [interval]="interval"
              [pauseOnHover]="true"
              [pauseOnFocus]="true"
              (slide)="onSlideChange($event)"
              [showNavigationIndicators]="false"
              #recommendCarousel="ngbCarousel"
            >
              <ng-container *ngFor="let item of recommendProductList; index as i">
                <ng-template ngbSlide id="recommend-slide-{{ i }}">
                  <div class="picsum-img-wrapper">
                    <img [src]="item.pos_product.image_url | imageUrl" alt="Recommend-product-{{ i }}" 
                    (error)="handleImageError($event)" />
                  </div>
                </ng-template>
              </ng-container>
            </ngb-carousel>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="currentPayment">
        <ng-container *ngIf="currentPayment.mode === 1">
          <div class="dashboard-header">
            <div class="dashboard-header-content">
              <div class="content-element">ยอดที่ต้องชำระ</div>
              <div class="content-element">
                {{ currentBill ? (currentBill.total_price - currentBill.total_discount | number : '1.2-2') : (0 | number : '1.2-2') }}
              </div>
              <div class="content-element">บาท</div>
            </div>
          </div>

          <div class="dashboard-body">
            <div class="dashboard-text-group">
              <div class="text-element">เงินที่ได้รับ</div>
              <div class="text-element">{{ currentPayment ? (currentPayment?.cash | number : '1.2-2') : (0 | number : '1.2-2') }}</div>
              <div class="text-element">บาท</div>
            </div>
            <div class="dashboard-text-group price-danger">
              <div class="text-element">ยอดชำระคงเหลือ</div>
              <div class="text-element">{{ currentPayment ? (currentPayment?.debt | number : '1.2-2') : (0 | number : '1.2-2') }}</div>
              <div class="text-element">บาท</div>
            </div>
            <div class="dashboard-text-group">
              <div class="text-element">เงินทอน</div>
              <div class="text-element">{{ currentPayment ? (currentPayment?.change | number : '1.2-2') : (0 | number : '1.2-2') }}</div>
              <div class="text-element">บาท</div>
            </div>

            <div class="dashboard-text-footer">ขอบคุณที่ใช้บริการ</div>
          </div>
        </ng-container>
        <ng-container *ngIf="currentPayment.mode === 2">
          <div class="dashboard-header">
            <div class="dashboard-header-content">
              <div class="content-element">ยอดที่ต้องชำระ</div>
              <div class="content-element">
                {{ currentBill ? (currentBill.total_price - currentBill.total_discount | number : '1.2-2') : (0 | number : '1.2-2') }}
              </div>
              <div class="content-element">บาท</div>
            </div>
          </div>
          <div class="dashboard-body">
            <div class="customer-detail-container">
              <div class="customer-detail-header">ข้อมูลลูกคัา</div>
              <div class="customer-detail-body">
                <div class="customer-detail-text">
                  <p>ชื่อ:</p>
                  <p>{{ currentPayment.customer.name }}</p>
                </div>
                <div class="customer-detail-text">
                  <p>เลขประจำตัวผู้เสียภาษี:</p>
                  <p>{{ currentPayment.customer.tax_no_hidden }}</p>
                </div>
                <div class="customer-detail-text">
                  <p>เบอร์โทรศัพท์:</p>
                  <p>{{ currentPayment.customer.phone_hidden }}</p>
                </div>
                <div class="customer-detail-text">
                  <p>ที่อยู่:</p>
                  <p>
                    {{ currentPayment.customer.address }}
                    ตำบล{{ currentPayment.customer.tambon_name_th }} อำเภอ{{ currentPayment.customer.amphur_name_th }} จังหวัด{{
                      currentPayment.customer.province_name_th
                    }}
                    {{ currentPayment.customer.post_code }}
                  </p>
                </div>
              </div>
            </div>
            <div class="dashboard-text-footer">ขอบคุณที่ใช้บริการ</div>
          </div>
        </ng-container>
        <ng-container *ngIf="currentPayment.mode === 3">
          <div class="dashboard-header">
            <div class="dashboard-header-content">
              <div class="content-element">ยอดที่ต้องชำระ</div>
              <div class="content-element">
                {{ currentBill ? (currentBill.total_price - currentBill.total_discount | number : '1.2-2') : (0 | number : '1.2-2') }}
              </div>
              <div class="content-element">บาท</div>
            </div>
          </div>
          <div class="dashboard-body">
            <div class="dashboard-text-group">
              <div class="text-element">เงินที่ได้รับ</div>
              <div class="text-element">{{ currentPayment ? (currentPayment?.cash | number : '1.2-2') : (0 | number : '1.2-2') }}</div>
              <div class="text-element">บาท</div>
            </div>
            <div class="dashboard-text-group price-danger">
              <div class="text-element">ยอดชำระคงเหลือ</div>
              <div class="text-element">{{ currentPayment ? (currentPayment?.debt | number : '1.2-2') : (0 | number : '1.2-2') }}</div>
              <div class="text-element">บาท</div>
            </div>

            <div class="qrcode-container" *ngIf="currentPayment.qr_code_image_url">
              <img [src]="imgHost + currentPayment.qr_code_image_url" alt="qrocde-payment" />
            </div>

            <div class="dashboard-text-footer">ขอบคุณที่ใช้บริการ</div>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>
